var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hmn-massive-recruitment',{attrs:{"is-my-processes":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }